import classNames from 'classnames';
import IconButton from 'components/common/IconButton';
import React, { useState } from 'react';
import { Button, Card, Col, Form, Row } from 'react-bootstrap';
import ReactFlagsSelect from 'react-flags-select';

const addressObj = {
  id: 1,
  country: 'PK',
  defaultAddress: true,
  postCode: '',
  addressLine1: '',
  addressLine2: '',
  cityOrTown: ''
};

const AddressInputs = () => {
  const [addresses, setAddress] = useState([{ ...addressObj }]);

  const onSelectCountryHandler = (code, id) => {
    const allAddresses = [...addresses];
    const selectedIndex = allAddresses.findIndex(address => address.id === id);
    if (selectedIndex > -1) {
      const selectedAddress = allAddresses[selectedIndex];
      selectedAddress.country = code;
      setAddress(allAddresses);
    }
  };

  const addAddressHandler = () => {
    const preAddresses = [...addresses];
    const newAddress = { ...addressObj };
    const lastAddressId = preAddresses[preAddresses.length - 1].id;
    newAddress.id = lastAddressId + 1;
    newAddress.defaultAddress = false;
    preAddresses.push(newAddress);
    setAddress(preAddresses);
  };

  const setAddDefaultAddress = id => {
    const allAddresses = [...addresses];
    const selectedIndex = allAddresses.findIndex(address => address.id === id);
    const preDefaultAddressIndex = allAddresses.findIndex(
      address => address.defaultAddress
    );

    if (selectedIndex > -1 && !allAddresses[selectedIndex].defaultAddress) {
      const preSelectedAddress = allAddresses[preDefaultAddressIndex];
      const selectedAddress = allAddresses[selectedIndex];
      preSelectedAddress.defaultAddress = false;
      selectedAddress.defaultAddress = true;
      setAddress(allAddresses);
    }
  };

  const deleteAddressHandler = id => {
    const allAddresses = [...addresses];
    const selectedIndex = allAddresses.findIndex(address => address.id === id);

    if (selectedIndex > -1) {
      allAddresses.splice(selectedIndex, 1);
      setAddress(allAddresses);
    }
  };

  return (
    <Card className="mb-3">
      {addresses.map((address, index) => (
        <Card key={address.id} className="shadow-none">
          <Card.Header>
            <Card.Title className="fw-medium d-flex justify-content-between align-items-center">
              <span>Donor #{index + 1} Address</span>

              <IconButton
                variant="light"
                icon="trash"
                className={classNames(
                  'mb-1 bg-transparent border-0 shadow-none',
                  { 'v-hidden': address.defaultAddress }
                )}
                iconAlign="left"
                transform="shrink-3"
                iconClassName="text-danger me-2"
                onClick={() => deleteAddressHandler(address.id)}
                disabled={address.defaultAddress}
              >
                Delete
              </IconButton>
            </Card.Title>
          </Card.Header>
          <Card.Body>
            <Row className="g-3">
              <Col md={12}>
                <Form.Label className="text-600">Country</Form.Label>
                <Row>
                  <Form.Group as={Col} md="6" controlId="title">
                    <ReactFlagsSelect
                      selected={address.country}
                      onSelect={code =>
                        onSelectCountryHandler(code, address.id)
                      }
                      className="react-select"
                      countries={['PK', 'fi', 'GB', 'IE', 'IT', 'NL', 'SE']}
                      selectButtonClassName="py-0"
                      selectedSize={17.3}
                      optionsSize={17.3}
                      // howSelectedLabel={showSelectedLabel}
                      // showOptionLabel={showOptionLabel}
                      // placeholder={placeholder}
                      // searchable={searchable}
                      // searchPlaceholder={searchPlaceholder}
                      // alignOptionsToRight={alignOptionsToRight}
                      // fullWidth={fullWidth}
                      // disabled={disabled}
                    />
                    <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
                  </Form.Group>

                  <Form.Group
                    as={Col}
                    md={6}
                    className="mt-1"
                    controlId={`address-${address.id}`}
                  >
                    <Form.Check
                      inline
                      type="radio"
                      name="primaryAddress"
                      id={`address-${address.id}`}
                      value={`address-${address.id}`}
                      className="me-2"
                      defaultChecked={address.defaultAddress}
                      onClick={() => setAddDefaultAddress(address.id)}
                    />
                    <Form.Label className="mb-0">
                      {address.defaultAddress ? 'Primary' : ''}
                    </Form.Label>
                  </Form.Group>
                </Row>
              </Col>
              <Form.Group
                as={Col}
                md="12"
                controlId={`postcode-${address.postCode}`}
              >
                <Form.Label>PostCode*</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="add Zip/post Code"
                  required
                />
                <Form.Control.Feedback type="invalid">
                  Please provide a valid zip/post code.
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group
                as={Col}
                md="12"
                controlId={`line-${address.addressLine1}`}
              >
                <Form.Label>Address Line 1*</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="First Address Line"
                  required
                />
                <Form.Control.Feedback type="invalid">
                  Please provide a valid First Address Line.
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group
                as={Col}
                md="12"
                controlId={`line2-${address.addressLine2}`}
              >
                <Form.Label>Address Line 2*</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Second Address Line"
                  required
                />
                <Form.Control.Feedback type="invalid">
                  Please provide a valid Second Address Line.
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group
                as={Col}
                md="12"
                controlId={`exampleZip-${address.cityOrTown}`}
              >
                <Form.Label>City / Town</Form.Label>
                <Form.Control type="text" placeholder="City / Town" required />
                <Form.Control.Feedback type="invalid">
                  Please provide a valid City / Town.
                </Form.Control.Feedback>
              </Form.Group>
            </Row>
          </Card.Body>
          {index !== addresses.length - 1 && <hr className="m-0" />}
        </Card>
      ))}
      <div className="p-3 pt-0">
        <Button
          variant="light"
          className="bg-transparent border-0 fs--1 fs-md-0 shadow-none text-primary p-1"
          onClick={addAddressHandler}
        >
          Add New Address
        </Button>
      </div>
    </Card>
  );
};

export default AddressInputs;
